<template>
  <MainContent>
      <div>
        <b-card no-body>
          <nx-bform
            ref="form"
            @submit="confirm"
          >
            <h5>{{ $t("heading") }}</h5>
            <nx-bform-server-errors name="server-errors" />
              <nx-bform-group :label="$t('activationKey') "    
              label-cols="2"
              label-align="right"
              >
                <nx-bform-input
                  :name="$t('activationKey')"
                  rules="required"
                  v-model="form.activationKey"
                />
              </nx-bform-group>
                                
            <LoginPasswordNewFormGroup
              v-model="form.newPassword"
              label-cols="2"
              label-align="right"
              required
            />

            <LoginPasswordFormGroup
              :label="$t('form.verify')"
              v-model="form.verifyPassword"
              label-cols="2"
              label-align="right"
              required
            />
            <CaptchaFormGroup
             style="padding-top :50px"
              label-cols="2"
              label-align="left"
              v-model="form.captcha"
              @change-token="form.captchaToken = $event.token"
              required
            />
            <b-form-group class="mt-2 justify-content-end">
              <b-button
                class="bd-button mr-2"
                 type="submit"
                >{{$t('confirm')}}</b-button
              >
              <b-button variant="danger" @click="back"
                >{{$t('back')}}</b-button
              >
            </b-form-group>
          </nx-bform>
        </b-card>
      </div>
  </MainContent>
</template>
<script>
import MainContent from "../../../components/main/MainContent";
import CaptchaFormGroup from "@/forms/common/CaptchaFormGroup";
import LoginPasswordFormGroup from "@/forms/login/LoginPasswordFormGroup";
import LoginPasswordNewFormGroup from "@/forms/login/LoginPasswordNewFormGroup";
import { UserApi } from "nx-libs";
import { EshCaptchaApi }  from "@/api";


export default {
  components: {
    MainContent,
    CaptchaFormGroup,
    LoginPasswordFormGroup,
    LoginPasswordNewFormGroup
  },
  data() {
    return {
      form: {
        activationKey:"",
        newPassword:"",
        verifyPassword:"",
        captcha:"",
        captchaToken:""
      }
    };
  },
  methods: {
    back() {
      this.$router.push({
        name: "LoginCps",
      });
    },    
   
    async confirm() {
      //const { targetUrl } = this;
      const { newPassword, verifyPassword,activationKey } = this.form;

      if (newPassword !== verifyPassword) {
        this.$dangerToast(this.$t("error"), this.$t("msg.pwMismatched"));
        return;
      }
      // try{
        await EshCaptchaApi.check(this.form.captchaToken);
        await UserApi.resetPassword({
          oldPwd: "",
          activationKey,
          newPwd1: newPassword,
          newPwd2: verifyPassword
        });

        this.$successToast(this.$t("success"), this.$t("msg.pwChanged"));

        this.$router.push({
          name: "LoginCps",
        });
      // }
      // catch ({response}) {
      //   if (response&&response.data) {
      //     console.log("response",response.data);
      //     const errorCode = response.data.split(/\s?:\s?/)[0];
      //     if (errorCode != 'invalid captcha') {
      //       this.errorMsg = errorCode + ": " + this.$t(`${errorCode}`);
      //     }
      //     else this.errorMsg = this.$t(`${errorCode}`);
      //     this.$dangerToast("Error",response.data);
      //   }
      // }

     
      
    },
  },
};
</script>
<style>
.green-text {
  color: #2b7366;
}

.header {
  background-color: #2b7366;
  color: white;
  font-size: 24px;
}

.info-header {
  text-align: center;
  background-color: #005d99;
  /*margin: auto;*/
}
.info-btn {
  text-align: center;
  margin-bottom: 30px;
}
.info-btn button {
  color: #fff;
  font-weight: 800;
  padding: 8px;
  border-radius: 0.25rem;
  background-color: #2b7366;
  border: none;
}
</style>

<i18n src="@/locales/login.locale"></i18n>
<i18n src="@/locales/actions.locale"></i18n>
<i18n>
{
  "en": {
    "heading":"Reset Password",
    "heading-new":"Set Password",
    "activationKey":"Activation Key",
    "form":{
      "verify":"Verify new password"
    },
    "msg": {
      "pwMismatched": "New password mismatched",
      "pwChanged": "Password changed. Redirecting to login...",
      "captchaError": "Captcha Error"
    }
  },
  "zh_hk": {
    "heading":"重置密碼",
    "heading-new":"設置密碼",
    "activationKey":"啟用金鑰",
    "form":{
      "verify":"確認新密碼"
    },
    "msg": {
      "pwMismatched": "新密碼不匹配",
      "pwChanged": "密碼已更改。重定向到登錄...",
      "captchaError": "Captcha Error"
    }
  },
  "zh_cn": {
    "heading":"重置密码",
    "heading-new":"设置密码",
    "activationKey":"启用金钥",
    "form":{
      "verify":"确认新密码"
    },
    "msg": {
      "pwMismatched": "新密码不匹配",
      "pwChanged": "密码已更改。重定向到登录...",
      "captchaError": "Captcha Error"
    }
  }
}
</i18n>